import React,{useState,useEffect}  from 'react';
import { useNavigate } from "react-router-dom";
import loader from '../../assets/Images/loader.gif';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SafPage = () => {
  const [safDataAll, setSafDataAll] = useState([]);
  const [safDataInsComplete, setSafDataInsComplete] = useState([]);
  const [safDataInsPending, setSafDataInsPending] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInputAll, setSearchInputAll] = useState('');
  const [searchInputInsComplete, setSearchInputInsComplete] = useState('');
  const [searchInputInsPending, setSearchInputInsPending] = useState('');
  const [searchFilter, setSearchFilter] = useState([]);
  const [flagAll,setFlagAll]=useState(false);
  const [flagInsComplete,setFlagInsComplete]=useState(false);
  const [flagInsPending,setFlagInsPending]=useState(false);


  useEffect(() => {
    const fetchData = async (status, dataFunction) => {
      try {
        setLoading(true);
        const currentDate = new Date();
        const formattedCurrentDate = currentDate.toISOString().split('T')[0];
        const toDate = formattedCurrentDate;
        const fromDate = new Date(currentDate);
        fromDate.setMonth(currentDate.getMonth() - 2);
        const formattedFromDate = fromDate.toISOString().split('T')[0];
  
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          "Action": "getAllSaf",
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "businessSegment": "",
          "fromDate": formattedFromDate,

          "password": sessionStorage.getItem('password'),
          "searchBoxValue": "",
          "status": status,
          "toDate": toDate,
          "userName": sessionStorage.getItem('userName')

      }
  
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        });
  
        if (response.ok) {
          const result = await response.json();
          // console.log('API Response:', result);
  
          if (result && result.Response && result.Response.Status !== "Failure" && result.Response.Data !== undefined) {
            // console.log('Actual Data:', result.Response.Data);
            dataFunction(result.Response.Data);
          } else {
            const errorMessage = (result && result.Response && result.Response.Message);
            // toast.warning(`${errorMessage}`, {
            //   position: toast.POSITION.BOTTOM_CENTER,
            //   autoClose: 1500
            // });
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        toast.error('Error fetching data. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchData("All", setSafDataAll);
    fetchData("Complete", setSafDataInsComplete);
    fetchData("Pending", setSafDataInsPending);
  }, []);

  const handleSearchAll = async () => {
    // console.log("Search button clicked");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getAllSaf",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "businessSegment": "",
        "fromDate": "",
        "password": sessionStorage.getItem('password'),
        "searchBoxValue": searchInputAll,
        "status": "All",
        "toDate": "",
        "userName": sessionStorage.getItem('userName')
    };

      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();

        if (result && result.Response && result.Response.Data) {
          setSearchFilter(result.Response.Data);
          setFlagAll(true);
        } else {
          // console.error("Invalid response format:", result);
          const errorMessage = (result && result.Response && result.Response.Message);
          // toast.warning(`${errorMessage}`, {
          //   position: toast.POSITION.BOTTOM_CENTER,
          //   autoClose: 1500
          // });
        }
      } else {
        console.error("Error fetching data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchComplete = async () => {
    // console.log("Search button clicked");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getAllSaf",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "businessSegment": "",
        "fromDate": "",
        "password": sessionStorage.getItem('password'),
        "searchBoxValue": searchInputInsComplete,
        "status": "Complete",
        "toDate": "",
        "userName": sessionStorage.getItem('userName')
    };

      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();

        if (result && result.Response && result.Response.Data) {
          setSearchFilter(result.Response.Data);
          setFlagInsComplete(true);
        } else {
          // console.error("Invalid response format:", result);
          const errorMessage = (result && result.Response && result.Response.Message);
          // toast.warning(`${errorMessage}`, {
          //   position: toast.POSITION.BOTTOM_CENTER,
          //   autoClose: 1500
          // });
        }
      } else {
        console.error("Error fetching data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchPending = async () => {
    // console.log("Search button clicked");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getAllSaf",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "businessSegment": "",
        "fromDate": "",
        "password": sessionStorage.getItem('password'),
        "searchBoxValue": searchInputInsPending,
        "status": "Pending",
        "toDate": "",
        "userName": sessionStorage.getItem('userName')
    };

      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();

        if (result && result.Response && result.Response.Data) {
          setSearchFilter(result.Response.Data);
          setFlagInsPending(true);
        } else {
          // console.error("Invalid response format:", result);
          const errorMessage = (result && result.Response && result.Response.Message);
          // toast.warning(`${errorMessage}`, {
          //   position: toast.POSITION.BOTTOM_CENTER,
          //   autoClose: 1500
          // });
        }
      } else {
        console.error("Error fetching data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const manageCafForm=(SafNo)=>{
    // console.log('SafNo',SafNo);
    
    navigate(`/businessSafmanageForm?SafNo=${SafNo}`);
  }
    const navigate = useNavigate();
    const redirectBusinessPage = () => {
      navigate("/business");
    };
    return (
    <>
        <div className="container-fluid text-light Header-style header">
              <div className="p-3">
                  <span className="" style={{ cursor: "pointer" }} onClick={redirectBusinessPage}>
                    <i className="fa-solid fa-arrow-left-long"></i>
                </span>
                <span className="p-1 m-3">Business SAF</span>
              </div>
                  {/* Navigation tabs: ALL Saf,Installation Pending , Installation completed */}
                <div className="scrollable-tabs saf-scroll-tab" >
                  <ul className="nav nav-tabs">
                    <li className="nav-item">
                      <a className="nav-link active" data-bs-toggle="tab" href="#allSaf">All</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" data-bs-toggle="tab"  href="#installComplete">Installation Completed</a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" data-bs-toggle="tab" href="#installPending">Installation Pending</a>
                    </li>
                  </ul>
                </div>
            </div>

            <div className="tab-content tab-main-content">
              {/* ****************** ALL CAF TAB ************* */}
              <div className="tab-pane fade show active" id="allSaf">
              <div className="container-fluid mb-3 mt-1  p-2 Searchbar-bg ">
                  <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
                    <span>
                      <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputAll}
              onChange={(e) => setSearchInputAll(e.target.value)}/>
                      <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button className='btn-sm border-0 bg-light' onClick={handleSearchAll}>Search</button>
                  </div>
                </div>

                {/* ***********All content of ALL SAF TAB************ */}

                {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  !flagAll && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {safDataAll.map((saf, index) => (
                       <div className="col" key={index} >
                    {/* <div className="col" key={index}>  */}
                      <div className="card mb-3" onClick={() => manageCafForm(saf.SafNo)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                          <p className="caf-card-title">{saf.ServiceID} ({saf.SafNo})</p>
                          <p className="caf-card-text">Mobile No : {saf.MobileNo}</p>
                          <p className="caf-card-text">Email ID : {saf.EmailId}</p>
                          <p className="caf-card-text">Status : {saf.SafStatus}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}

            {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  flagAll && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {searchFilter.map((saf, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageCafForm(saf.SafNo)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                          <p className="caf-card-title">{saf.ServiceID} ({saf.SafNo})</p>
                          <p className="caf-card-text">Mobile No : {saf.MobileNo}</p>
                          <p className="caf-card-text">Email ID : {saf.EmailId}</p>
                          <p className="caf-card-text">Status : {saf.SafStatus}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}
              </div>

                {/* ****************** Complete TAB ************* */}
              <div className="tab-pane fade show" id="installComplete">
                <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
                  <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
                    <span>
                      <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputInsComplete}
              onChange={(e) => setSearchInputInsComplete(e.target.value)}/>
                      <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button className='btn-sm border-0 bg-light' onClick={handleSearchComplete}>Search</button>
                  </div>
                </div>

                {/* ***********All content of complete TAB************ */}

                {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  !flagInsComplete && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {safDataInsComplete.map((saf, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageCafForm(saf.SafNo)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                          <p className="caf-card-title">{saf.ServiceID} ({saf.SafNo})</p>
                          <p className="caf-card-text">Mobile No : {saf.MobileNo}</p>
                          <p className="caf-card-text">Email ID : {saf.EmailId}</p>
                          <p className="caf-card-text">Status : {saf.SafStatus}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}

            {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  flagInsComplete && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {searchFilter.map((saf, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageCafForm(saf.SafNo)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                          <p className="caf-card-title">{saf.ServiceID} ({saf.SafNo})</p>
                          <p className="caf-card-text">Mobile No : {saf.MobileNo}</p>
                          <p className="caf-card-text">Email ID : {saf.EmailId}</p>
                          <p className="caf-card-text">Status : {saf.SafStatus}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}
              </div>

              {/* ****************** closed Inst Pending TAB ************* */}
              <div className="tab-pane fade show" id="installPending">
                <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
                  <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
                    <span>
                      <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} value={searchInputInsPending}
              onChange={(e) => setSearchInputInsPending(e.target.value)}/>
                      <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button className='btn-sm border-0 bg-light' onClick={handleSearchPending}>Search</button>
                  </div>
                </div>

                {/* ***********All content of Inst Pending TAB************ */}

                {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  !flagInsPending && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {safDataInsPending.map((saf, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageCafForm(saf.SafNo)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                          <p className="caf-card-title">{saf.ServiceID} ({saf.SafNo})</p>
                          <p className="caf-card-text">Mobile No : {saf.MobileNo}</p>
                          <p className="caf-card-text">Email ID : {saf.EmailId}</p>
                          <p className="caf-card-text">Status : {saf.SafStatus}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}

            {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  flagInsPending && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {searchFilter.map((saf, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => manageCafForm(saf.SafNo)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                          <p className="caf-card-title">{saf.ServiceID} ({saf.SafNo})</p>
                          <p className="caf-card-text">Mobile No : {saf.MobileNo}</p>
                          <p className="caf-card-text">Email ID : {saf.EmailId}</p>
                          <p className="caf-card-text">Status : {saf.SafStatus}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}
              </div>
            </div>
    </>
  )
}

export default SafPage
